import ReactDOM from 'react-dom/client';
import { HelmetProvider } from 'react-helmet-async';
import './index.css';
import App from './App';

// Add the Google Sign-In script
{/*}
const loadGoogleScript = () => {
  const script = document.createElement('script');
  script.src = 'https://apis.google.com/js/platform.js';
  script.async = true;
  script.defer = true;
  document.head.appendChild(script);
  // Add meta tag for client ID
  const meta = document.createElement('meta');
  meta.name = 'google-signin-client_id';
  meta.content = 'YOUR_CLIENT_ID.apps.googleusercontent.com'; // Replace with your client ID
  document.head.appendChild(meta);
};
loadGoogleScript();
*/}

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);

//const root = ReactDOM.createRoot(
//  document.getElementById('root') as HTMLElement
//);
//root.render(
//  <React.StrictMode>
//    <App />
//  </React.StrictMode>
//);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
//reportWebVitals();